/**
 * Interface for custom error messages in form controls
 * Supports placeholder replacement: {min}, {max}
 */
export interface ErrorMessages {
  required?: string;
  requiredTrue?: string;
  email?: string;
  minlength?: string;
  maxlength?: string;
  fileTooLarge?: string;
  invalidFileType?: string;
  invalidFile?: string;
  passwordConfirmMatches?: string;
  invalidUrl?: string;
  weakPassword?: string;
  incompleteDate?: string;
  invalidTaxationNumber?: string;
  invalidCommercialRegisterNumber?: string;
  pattern?: string;
  [key: string]: string | undefined;
}

/** Interface for mapping form field names to their display labels */
export interface FieldLabels {
  [key: string]: string;
}

/** Interface for custom labels for different error types */
export interface ErrorTypeLabels {
  [key: string]: string;
}

/** Default labels for error types */
export const DEFAULT_ERROR_TYPE_LABELS: ErrorTypeLabels = {
  required: 'This field is required',
  email: 'Please enter a valid email address',
  minlength: 'Minimum {min} characters required',
  maxlength: 'Maximum {max} characters allowed',
  invalidUrl: 'Please enter a valid URL',
  invalidTaxationNumber: 'Please enter a valid tax ID number (e.g., DE123456789)',
  invalidCommercialRegisterNumber: 'Please enter a valid commercial register number (e.g., HRB123456)',
  incompleteDate: 'Please enter a complete date (DD.MM.YYYY)',
  invalidFileType: 'Only PDF files are allowed',
  invalidFile: 'The selected file is invalid',
  pattern: 'Invalid format'
};
